import { Col, FormInstance, Row } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { components } from 'react-select';
import { Checkbox } from 'components/atoms/checkbox';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import { Select } from 'components/atoms/select';
import { VirtualizedMenuList } from 'components/atoms/select/custom-components';
import { Option } from 'components/atoms/select/types';
import { ProjectOption } from 'components/organisms/timesheets/common/project-option';
import { useTranslation } from 'hooks/use-translation';

interface Props {
  form: FormInstance;
  onFormValueChange: (changedValues, values) => void;
  projectOptions: Option[];
  categoryOptions: Option[];
  isBillableFieldDisabled: boolean;
  categoryMandatory: boolean;
}

export const NewActivityForm: FC<Props> = ({
  form,
  onFormValueChange,
  projectOptions,
  categoryOptions,
  isBillableFieldDisabled,
  categoryMandatory,
}) => (
  <Form
    layout="vertical"
    form={form}
    initialValues={{ billable: true }}
    onValuesChange={onFormValueChange}
  >
    <Row>
      <Col span={24}>
        <Form.Item
          label={<FormattedMessage id="projects.list.projectName" />}
          name="project"
          required
          data-cy="inputs.project-name"
        >
          <Select
            type="user"
            options={projectOptions}
            components={{
              Option: ProjectOption,
              MenuList: VirtualizedMenuList,
              SingleValue: components.SingleValue,
            }}
            noOptionsMessage={() => (
              <FormattedMessage id="projects.no_results.empty.title" />
            )}
          />
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col span={24}>
        <Form.Item
          label={<FormattedMessage id="timesheets.labels.activity_name" />}
          name="activityName"
          required
          data-cy="inputs.activity-name"
        >
          <Input
            autoComplete="off"
            placeholder={useTranslation(
              'timesheets.placeholders.activity_name',
            )}
          />
        </Form.Item>
      </Col>
    </Row>
    <Row align="middle" gutter={16}>
      <Col span={16}>
        <Form.Item
          label={<FormattedMessage id="timesheets.column.choose_category" />}
          name="category"
          data-cy="inputs.category"
          required={categoryMandatory}
        >
          <Select options={categoryOptions} type="tag" maxMenuHeight={250} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          name="billable"
          valuePropName="checked"
          label={<FormattedMessage id="timesheets.column.billable" />}
        >
          <Checkbox
            disabled={isBillableFieldDisabled}
            data-cy="inputs.billable"
            defaultChecked
          />
        </Form.Item>
      </Col>
    </Row>
  </Form>
);
